import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserReferral } from '../models';

@Injectable()
export class ReferralEmailService {
  private readonly _serviceName = 'ReferralEmailService';

  constructor(private http: HttpClient) { }

  sendEmail(userId: number) {
    this.http.get('adminreferral/referral/' + userId).subscribe(response => {
      //this just needs a subscribe to work. not doing anything with the response.
      //all checks and logging are handled by the backend.
    });
  }

}